<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
      @openEditDialog="openEditDialog"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @buildHsCode="buildHsCode"
        @editHsCode="editHsCode"
        :checked-count="checkedCount"
      />
    </page-main>

    <EditHsCode
      :title="$l('INDEX.dialog_title_edit_customs_info') || '编辑报关信息'"
      :visible.sync="editHsCodeOptions.visible"
      :shipmentCode="shipmentCode"
      :listGoods="editHsCodeOptions.listGoods"
      @reload="editHscodeReload"
    />
    <EditForm
      :title="$l('INDEX.dialog_title_edit_gods_info') || '编辑产品信息'"
      :visible.sync="editFormOptions.visible"
      :shipmentCode="shipmentCode"
      :orderGoodsCode="editFormOptions.orderGoodsCode"
      :masterCategoryCode="editFormOptions.masterCategoryCode"
      @reload="editReload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import EditHsCode from '../edit-hscode'
import EditForm from '../edit-form'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageHeader, PageMain, EditHsCode, EditForm },
  mixins: [BaseTable, EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      checkedRow: [],
      editHsCodeOptions: { visible: false, listGoods: [] },
      editFormOptions: {
        visible: false,
        orderGoodsCode: '',
        masterCategoryCode: '',
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      if (!this.shipmentCode) return
      const params = { ...form, shipmentCode: this.shipmentCode }
      this.loading = true
      this.$api
        .shipmentBatchBoxGoodsListApi(params)
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    async buildHsCode() {
      this.loadingOpen()
      const res = await this.$api
        .shipmentHscodeGoodsBuilderDataApi({
          shipmentCode: this.shipmentCode,
        })
        .catch(() => null)
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.reload()
    },
    editHsCode() {
      if (!this.checkedCount) return

      const { masterCategoryCode } = this.checkedRow[0]

      const result = this.checkedRow.every(
        (item) => masterCategoryCode === item.masterCategoryCode
      )

      if (!result) {
        this.$message({
          message: this.$l('INDEX.edit_goods_hscode') || '请选择相同分类的产品',
          type: 'warning',
        })
        return
      }

      this.openEditHsCode(this.checkedRow)
    },
    openEditHsCode(listGoods) {
      this.editHsCodeOptions = {
        visible: true,
        listGoods,
      }
    },
    editHscodeReload() {
      this.reload()
      this.checkedRow = []
    },
    openEditDialog(e) {
      const { orderGoodsCode, isGroup, masterCategoryCode } = e
      // 套件可编辑规格信息
      if (isGroup === 'Y') {
        this.editFormOptions = {
          visible: true,
          orderGoodsCode,
          masterCategoryCode,
        }
        return
      }

      // 不是套件不可编辑规格信息，直接打开编辑报关信息弹框
      this.openEditHsCode([e])
    },
    editReload() {
      this.reload()
      this.$refs.main.specReload()
    },
  },
}
</script>
